import { FILTERS, readSelections } from './model';

export type InventoryFilterDraft = {
  identity: string;
  values: Record<string, Array<string>>;
  blackout: string;
  resetScope: boolean;
};
export const inventoryLocationIdentity = (pathname: string, search: string) => JSON.stringify([pathname, search]);

export function createInventoryFilterDraft(pathname: string, search: string): InventoryFilterDraft {
  const params = new URLSearchParams(search);
  return {
    identity: inventoryLocationIdentity(pathname, search),
    values: readSelections(params),
    blackout: params.get('ri_blackout_adjusted') === 'No' ? 'No' : 'Yes',
    resetScope: false,
  };
}
export function resetInventoryFilterDraft(draft: InventoryFilterDraft): InventoryFilterDraft {
  return { ...draft, values: readSelections(new URLSearchParams()), blackout: 'Yes', resetScope: true };
}
export function inventoryFilterChanges(draft: InventoryFilterDraft): Record<string, string | Array<string>> {
  return {
    ...Object.fromEntries(FILTERS.map(([key]) => [key, draft.values[key].length ? draft.values[key] : ['__ALL__']])),
    blackout_adjusted: draft.blackout,
    ...(draft.resetScope ? { as_at: 'Latest', from: '', to: '', selected_vendor: [], selected_date: [] } : {}),
  };
}
